const ActionType = {
  SET_EXTERNAL_ACCESS_CONFIG: 'SET_EXTERNAL_ACCESS_CONFIG',
};

export default ActionType;
